

module.exports = __webpack_require__.stylable.create(
    "NewCard2036264276",
    {"classes":{"root":"NewCard2036264276__root","container":"NewCard2036264276__container"},"vars":{},"stVars":{"DefalutRatio":"50","Ratio":"--overridable"},"keyframes":{}},
    "",
    1,
    "NewCard2036264276",
    null
);
